import React from 'react';
import PropTypes from 'prop-types';

function Waiting({visible}) {
  if (!visible) {
    return null;
  }
  return <div className="waiting"/>;
}

Waiting.defaultProps = {
  visible: true
};

Waiting.propTypes = {
  visible: PropTypes.bool
};

export default Waiting;



// WEBPACK FOOTER //
// ./src/js/Component/Waiting.jsx